import { PlaygroundConversation } from '@/components/PlaygroundConversation';
import { Conversation } from 'components';
import { Button } from 'components/shadcn/button';
import { Card, CardContent, CardHeader } from 'components/shadcn/card';
import { ScrollArea } from 'components/shadcn/scroll-area';
import { useRTL } from 'hooks';
import { RefreshCcw } from 'lucide-react';
import { UpdateChatForm } from 'pages/dashboard';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const EditChat = () => {
  const { t } = useTranslation();
  const { isRTL } = useRTL();
  const containerRef = useRef<HTMLDivElement>(null);
  const formRef = useRef<HTMLFormElement>(null);

  const handleExternalButtonClick = () => {
    formRef.current?.requestSubmit();
  };

  const conversationRef = useRef<{ restartConversation: () => void }>(null);

  const handleRestart = () => {
    conversationRef.current?.restartConversation();
  };

  return (
    <div className="flex gap-4 animate-in fade-in zoom-in-95 duration-500 ease-out">
      <ScrollArea className="h-[calc(100vh-64px)] flex-1" dir={isRTL ? 'rtl' : 'ltr'}>
        <div className="animate-in slide-in-from-bottom-8 fade-in duration-700 delay-100 fill-mode-backwards">
          <h1 className="text-xl py-6 px-8 font-semibold tracking-tight text-balance">
            {t('dashboard.editChat.title')}
          </h1>
          <UpdateChatForm ref={formRef} />
        </div>
        <div className="sticky bottom-4 w-full flex justify-center py-4 pointer-events-none">
          <Button
            onClick={handleExternalButtonClick}
            type="submit"
            variant="secondary"
            className="pointer-events-auto w-[300px] max-w-[90%] bg-gradient-to-r from-primary to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white shadow-lg shadow-purple-500/20 hover:shadow-xl hover:shadow-purple-500/40 active:scale-95 active:shadow-sm transition-all duration-300"
          >
            {t('dashboard.editChat.saveChanges')}
          </Button>
        </div>
      </ScrollArea>
      <Card className="flex-1 my-8 me-8 border-none shadow-xl shadow-slate-200/50 dark:shadow-none ring-1 ring-slate-200 dark:ring-slate-800 transition-shadow duration-300 hover:shadow-2xl animate-in fade-in slide-in-from-bottom-4 duration-500 fill-mode-backwards delay-200">
        <CardHeader className="h-16 flex flex-row justify-between items-center">
          <h1 className="text-xl text-balance">{t('dashboard.editChat.conversation')}</h1>
          <Button className="!mt-0 gap-4" onClick={handleRestart} variant="link">
            <RefreshCcw className="h-4 w-4" />
            <h2 className="text-l text-balance">{t('dashboard.editChat.restartConversation')}</h2>
          </Button>
        </CardHeader>
        <CardContent>
          <ScrollArea className={`h-[calc(100vh-250px)] flex-col flex`} ref={containerRef}>
            <PlaygroundConversation
              ref={conversationRef}
              className={'h-[calc(100vh-250px)]'}
              newMessageScrollTarget={containerRef}
            />
          </ScrollArea>
        </CardContent>
      </Card>
    </div>
  );
};
